import React, { PropsWithChildren } from 'react'
import { HStack } from '../../bases/HStack'
import { Text } from '../../bases/Text'
import { Clickable } from '../../bases/Clickable'
import Image from 'next/image'
import IconArrowLeft from '@/public/images/iconArrowLeft.png'
import IconArrowRight from '@/public/images/iconArrowRight.png'
import { Center } from '../../bases/Center'

export type Props = {
  allCount: number
  maxPage: number
  currentPage: number
  onClickPage: (page: number) => void
}

export const Paging: React.VFC<Props> = (props) => {
  const Pagination = () => {
    const { currentPage, maxPage, onClickPage } = props
    const displayPages = []
    const items = []

    for (let i = 1; i <= maxPage; i++) {
      if (
        i == 1 ||
        i == maxPage ||
        (currentPage < 5 && i <= 7) ||
        (maxPage - currentPage < 5 && i > maxPage - 7) ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        displayPages.push(i)
      }
    }

    let previousPage = 0

    for (const page of displayPages) {
      if (previousPage) {
        if (page - previousPage === 2) {
          items.push(
            <PageIcon
              key={`page_${previousPage + 1}`}
              onClick={() => onClickPage(previousPage + 1)}
              selected={previousPage + 1 === currentPage}
            >
              <Text className="text-base font-semibold text-white">{previousPage + 1}</Text>
            </PageIcon>,
          )
        } else if (page - previousPage > 2) {
          items.push(<Ellipsis key={`page_${previousPage + 1}`} />)
        }
      }
      items.push(
        <PageIcon key={`page_${page}`} onClick={() => onClickPage(page)} selected={page === currentPage}>
          <Text className="text-base font-semibold text-white">{page}</Text>
        </PageIcon>,
      )
      previousPage = page
    }

    return <>{items.map((e) => e)}</>
  }

  return (
    <HStack className="flex-wrap justify-center gap-2 py-3">
      <PageIcon onClick={() => props.currentPage !== 1 && props.onClickPage(props.currentPage - 1)}>
        <Image src={IconArrowLeft} height={32} width={32} alt="left" />
      </PageIcon>
      {props.maxPage <= 9 ? (
        [...Array(props.maxPage ? props.maxPage : 1)].map((_, i) => (
          <PageIcon
            key={`page_${i + 1}`}
            onClick={() => props.onClickPage(i + 1)}
            selected={i + 1 === props.currentPage}
          >
            <Text
              className={`font-semibold text-white ${String(i + 1).length >= 3 ? 'text-sm' : 'text-base'}`}
            >
              {i + 1}
            </Text>
          </PageIcon>
        ))
      ) : (
        <Pagination />
      )}
      <PageIcon
        onClick={() => props.currentPage !== props.maxPage && props.onClickPage(props.currentPage + 1)}
      >
        <Image src={IconArrowRight} height={32} width={32} alt="right" />
      </PageIcon>
    </HStack>
  )
}

const PageIcon = (props: PropsWithChildren<{ onClick: () => void; selected?: boolean }>) => (
  <Clickable
    className={`h-8 w-8 items-center justify-center rounded-md p-1.5 ${
      props.selected ? 'bg-akiverse-pink' : 'border border-white/40'
    }`}
    onClick={props.onClick}
  >
    {props.children}
  </Clickable>
)

const Ellipsis = () => (
  <Center className="h-8 w-8 items-center justify-center rounded-md p-1.5">
    <Text className="text-base font-semibold text-white/40">...</Text>
  </Center>
)
